
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MLoading',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: 'Weelife'
    }
  },
  setup() {
    return {}
  }
})
